import styled from "styled-components"

export const Accent = styled.span`
    color: var(--accent-color);
`

export const StyledTitle = styled.h1`
    font-size: 3.6rem;
    text-align: center;
    display: block;
    margin-bottom: 2rem;
    margin-top: 3rem;
    `

export const Strong = styled.strong`
    font-weight: bold;
`